import React, { useState } from "react";
import * as Cookies from "js-cookie";
import { navigate } from "@reach/router"



export const removeSessionCookie = () => {
  Cookies.remove("session");
};

export const setSessionCookie = (session) => {
  Cookies.remove("session");
  Cookies.set("session", session, { expires: 14 });
};

export const getSessionCookie = () => {
  const sessionCookie = Cookies.get("session");

  if (sessionCookie === undefined) {
    return {};
  } else {
    return JSON.parse(sessionCookie);
  }
};
console.log("CREATED");
export const SessionContext = React.createContext({
  authToken: getSessionCookie().authToken,
  userID: getSessionCookie().userID, 
  setSession: () => {},
  logoutUser: () => {},
  loginUser: () => {}
});

export const SessionContextProvider = (props) => {



  const setSession = ({authToken, userID}) => {
    setSessionCookie({authToken, userID});

    console.log();

    setState({
      ...state, 
      authToken: getSessionCookie().authToken,
      userID: getSessionCookie().userID
    })
  }


  const logoutUser = () => {
    removeSessionCookie();
    setSession({});
    navigate('/login');
  };

  const loginUser = data => {
    const s = {authToken: data.auth_token, userID: data.user_id};
    setSessionCookie(s)
    setSession(s);
    navigate('/profile');
  };

  const initState = {
    authToken: getSessionCookie().authToken,
    userID: getSessionCookie().userID,
    setSession: setSession,
    logoutUser: logoutUser,
    loginUser: loginUser,
  } 






  const [state, setState] = useState(initState);


  return (
    <SessionContext.Provider value={state}>
      {props.children}
    </SessionContext.Provider>
  )
}